import styled from 'styled-components';
import { breakpoints, colors } from 'components/Theme';
import { asRem } from 'utils';

export default styled.div`
  margin-top: ${({ hasNotification }) => (hasNotification ? asRem(150) : asRem(80))};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${({ backgroundColor }) => backgroundColor || colors.blue.c800};
  color: ${colors.white.c500};
  position: relative;
  padding: 0 !important;
  z-index: 100;

  margin-bottom: -${asRem(10)};

  @media (min-width: ${breakpoints.md}) {
    padding: ${asRem(20)} 0 0;
    margin-top: ${({ hasNotification }) => (hasNotification ? asRem(120) : asRem(80))};
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media (min-width: ${breakpoints.md}) {
      flex-direction: row;
    }

    .text-wrapper {
      margin: 0 ${asRem(24)};
      flex: 2;
      padding: ${asRem(25)} 0 0;

      @media (min-width: ${breakpoints.md}) {
        margin: 0;
      }
    }

    .wrapper {
      display: none;
      flex: 0;
      align-items: flex-end;
      height: ${asRem(115)};

      @media (min-width: ${breakpoints.md}) {
        display: flex;
      }
    }

    .left-img-wrapper {
      justify-content: flex-end;
      z-index: 5;
      align-items: center;
      margin-right: ${asRem(40)};
    }

    .right-img-wrapper {
      justify-content: flex-start;
      align-items: center;
      margin-left: ${asRem(40)};
    }

    .left-image {
      height: ${asRem(100)};
    }

    .right-image {
      height: ${asRem(80)};
    }

    // Specific styles for Black Friday Banner
    .bf-mountain,
    .bf-balloonie,
    .bf-mobile-image {
      align-self: flex-end;
    }
  }

  .mobile-image {
    display: flex;
    height: ${asRem(80)};
    margin-top: -${asRem(15)};

    @media (min-width: ${breakpoints.md}) {
      display: none;
    }
  }

  // Specific styles for New Year Banner
  .ny-mobile-image {
    margin-bottom: ${asRem(10)};
  }

  .mime-elements-headline-2 {
    margin-bottom: ${asRem(4)};
  }

  .mime-elements-paragraph {
    margin-bottom: ${asRem(24)};
  }
`;
